module.exports = __webpack_public_path__ + "static/media/7.4ac7ef34.jpeg";